import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import { ProjectId, UserId } from 'api/models';
import { ProjectAPI } from 'api/project';
import { InvitedMembers } from 'data/members/slice';
import { addMembersToProject } from 'data/projects/actions';
import { add } from 'stores/memberships';

interface Callback {
  (data: any): void;
}

function* addMemberToProjectSaga(
  action: PayloadAction<{
    projectId: number;
    members: InvitedMembers[];
    handleSuccess?: Callback;
    handleFailure?: Callback;
  }>,
) {
  const { payload } = action;
  const { projectId, members, handleSuccess, handleFailure } = payload;

  try {
    const response = yield ProjectAPI.addMembers(projectId, members);

    if (handleSuccess) {
      handleSuccess(payload);
    }

    yield put(
      add({
        projectId: ProjectId(projectId),
        memberships: response.map(
          ({
            user: { userId },
            permissionSet: { permissionSetType: memberType },
            joinedAt,
          }) => ({ userId: UserId(userId), memberType, joinedAt }),
        ),
      }),
    );
  } catch (error) {
    if (handleFailure) {
      handleFailure(error);
    }
  }
}

export const watchAddMemberToProjectSaga = function* (): Generator {
  yield takeLatest(addMembersToProject.type, addMemberToProjectSaga);
};
